var _path, _path2, _path3, _path4;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgCrystal(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 80,
    height: 80,
    viewBox: "0 0 80 80",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.75 40L40 80l14.843-51.421L11.749 40z",
    fill: "#4C77CE"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M40 0L11.75 40l34.39 2.053L40 0z",
    fill: "#C0D1FF"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M68.25 40L40 0l6.14 42.053L68.25 40z",
    fill: "#6F94E4"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M46.14 42.053L40 80l28.25-40-22.11 2.053z",
    fill: "#214FAC"
  })));
}

export default __webpack_public_path__ + "./fonts/crystal.cb9f9487abafd101717151bbea9852a0.svg";
export { SvgCrystal as ReactComponent };